import { styled } from 'styled-components';
import { Box } from '@design-system/box';
import { primaryShadow } from '@design-system/theme';
export const Banner = styled(Box).attrs(({ theme }) => ({
    bg: theme.themeVariables.frameBackgroundColor,
    width: '100%',
    minHeight: { _: 250, m: 150, l: 150, xl: 150 },
    flexDirection: { _: 'column', m: 'row', l: 'row', xl: 'row' },
    justifyContent: 'space-around',
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
})) `
  z-index: ${({ theme }) => theme.zIndices.modal};
  ${primaryShadow}
`;
//# sourceMappingURL=Banner.js.map